export default "__VITE_ASSET__Dqc6ilaX__"